module.exports = __webpack_public_path__ + "img/canada-eye-and-ear-diseases-male.f1996b2e.png";